<template>
  <div class="hidden-text">
    <p :style="maskStyles">{{ text }}</p>
  </div>
</template>

<script>
const THRESHOLD = 2;

export default {
  props: {
    maxDimensions: {
      type: Object,
      default: () => ({ height: 0, width: 0 }),
    },
    text: {
      type: String,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  computed: {
    maskStyles() {
      const left = this.maxDimensions.left;
      const top = this.maxDimensions.top;
      const width = this.maxDimensions.width;
      const height = this.maxDimensions.height;

      const textRegions = [...document.querySelectorAll('.textLayer span')];

      const maskedTextRegions = textRegions.filter((text, i) => {
        const { offsetTop, offsetHeight, offsetLeft, offsetWidth } = text;
        return (
          Math.floor(left - THRESHOLD) <= offsetLeft &&
          Math.floor(left + THRESHOLD) + Math.floor(width) >=
            offsetLeft + offsetWidth &&
          Math.floor(top - THRESHOLD) <= offsetTop &&
          Math.floor(top + THRESHOLD) + Math.floor(height) >=
            offsetTop + offsetHeight
        );
      });

      const fontSizes = maskedTextRegions.map((text) =>
        this.transformStyleVal(text.style.fontSize),
      );
      const foundText = fontSizes.length > 0;
      const paddingLeft = maskedTextRegions.reduce(
        (plAcc, text) => Math.min(plAcc, text.offsetLeft - left),
        foundText ? width : 1,
      );

      const paddingTop = maskedTextRegions.reduce(
        (ptAcc, text) => Math.min(ptAcc, text.offsetTop - top),
        foundText ? height : 1,
      );

      const fontSize = foundText
        ? fontSizes.reduce((sum, size) => sum + size, 0) / fontSizes.length
        : Math.min(height - 4, 12 * this.zoomFactor);

      return {
        '--first-line-height': `${fontSize}px`, // Sets the CSS variable --first-line-height
        fontSize: `${fontSize}px`,
        paddingTop: `${paddingTop - 1}px`,
        paddingLeft: `${paddingLeft - 1}px`,
        paddingRight: `${paddingLeft - 1}px`,
      };
    },
  },
  methods: {
    transformStyleVal(val) {
      return parseFloat(val.replace('px'));
    },
  },
};
</script>
